import { useState, useEffect } from 'react';

export const useInput = value => {
  const empty = value === undefined || value === '' || value === null;

  const [shrinked, setShrinked] = useState(!empty);
  const [focused, setFocused] = useState(false);

  const handleFocus = () => {
    setShrinked(true);
    setFocused(true);
  };

  const handleBlur = () => {
    setShrinked(!empty);
    setFocused(false);
  };

  useEffect(() => {
    setShrinked(!empty);
  }, [empty, value]);

  return { handleBlur, handleFocus, shrinked, focused };
};
